import { render, staticRenderFns } from "./AppStoreReviewBlock.vue?vue&type=template&id=0aea963d&scoped=true"
import script from "./AppStoreReviewBlock.vue?vue&type=script&lang=js"
export * from "./AppStoreReviewBlock.vue?vue&type=script&lang=js"
import style0 from "./AppStoreReviewBlock.vue?vue&type=style&index=0&id=0aea963d&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aea963d",
  null
  
)

export default component.exports